import script from "./DisableAccessAsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DisableAccessAsModal.vue?vue&type=script&setup=true&lang=ts"

import "./DisableAccessAsModal.vue?vue&type=style&index=0&id=5627b9eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5627b9eb"]])

export default __exports__